import React, { FC } from 'react'

interface PreviewProviderContextProps {
  previewValues: Record<string, any>
  setPreviewValues: React.Dispatch<React.SetStateAction<Record<string, any>>>
}

const PreviewProviderContext = React.createContext<PreviewProviderContextProps | null>(null)

interface PreviewProviderProps {
  children: React.ReactNode
}

export const PreviewProvider: FC<PreviewProviderProps> = ({ children }) => {
  const [previewValues, setPreviewValues] = React.useState<Record<string, any>>({})

  return (
    <PreviewProviderContext.Provider value={{ previewValues, setPreviewValues }}>
      {children}
    </PreviewProviderContext.Provider>
  )
}

export const usePreviewProvider = (): PreviewProviderContextProps => {
  const PreviewProviderModule = React.useContext(PreviewProviderContext)

  if (!PreviewProviderModule)
    throw new Error('usePreviewProvider must be used within an PreviewProviderModule')

  return PreviewProviderModule
}
